import React, { useContext } from 'react';
import { Text, TextTypography, TPAComponentsContext } from 'wix-ui-tpa';
import { style, classes } from './AvatarRole.st.css';
import Avatar from './Avatar';
import he from 'he';
function AvatarRole(props) {
    const { rtl, mobile } = useContext(TPAComponentsContext);
    const { role, description, icon, displayDescription, roleID } = props;
    return (React.createElement("div", { className: style(classes.root, { rtl, mobile }, props.className) },
        React.createElement(Avatar, { icon: icon, name: role }),
        React.createElement(Text, { className: style(classes.roleBlock) },
            React.createElement(Text, { id: `role${roleID}`, typography: TextTypography.runningText, className: style(classes.enhancedText) }, he.decode(role || '')),
            React.createElement(Text, { id: `role${roleID}_desc`, typography: TextTypography.runningText, className: style(classes.description) }, displayDescription && he.decode(description || '')))));
}
export default AvatarRole;
//# sourceMappingURL=AvatarRole.js.map